// Security utilities
export const isSecureConnection = () => {
  return window.location.protocol === 'https:' || window.location.hostname === 'localhost';
};

// Rate limiting for client-side operations
export class RateLimiter {
  constructor(maxRequests = 10, windowMs = 60000) {
    this.maxRequests = maxRequests;
    this.windowMs = windowMs;
    this.requests = new Map();
  }
  
  canMakeRequest(key = 'default') {
    const now = Date.now();
    const windowStart = now - this.windowMs;
    
    if (!this.requests.has(key)) {
      this.requests.set(key, []);
    }
    
    const userRequests = this.requests.get(key);
    
    // Remove old requests outside the window
    const validRequests = userRequests.filter(time => time > windowStart);
    this.requests.set(key, validRequests);
    
    if (validRequests.length >= this.maxRequests) {
      return false;
    }
    
    validRequests.push(now);
    return true;
  }
}

// Content Security Policy helpers
export const setupCSP = () => {
  const meta = document.createElement('meta');
  meta.httpEquiv = 'Content-Security-Policy';
  meta.content = `
    default-src 'self';
    script-src 'self' 'unsafe-inline' 'unsafe-eval' https://apis.google.com https://www.gstatic.com https://inklinkor.com https://*.propellerads.com https://*.monetag.com https://groleegni.net;
    style-src 'self' 'unsafe-inline' https://fonts.googleapis.com https://*.propellerads.com https://*.monetag.com https://groleegni.net;
    font-src 'self' https://fonts.gstatic.com https://*.propellerads.com https://*.monetag.com https://groleegni.net;
    img-src 'self' data: https://firebasestorage.googleapis.com https://media.tenor.com https://*.propellerads.com https://*.monetag.com https://inklinkor.com https://groleegni.net;
    connect-src 'self' https://*.googleapis.com https://*.firebase.com wss://*.firebase.com https://*.propellerads.com https://*.monetag.com https://inklinkor.com https://groleegni.net;
    frame-src 'self' https://*.propellerads.com https://*.monetag.com https://groleegni.net;
  `.replace(/\s+/g, ' ').trim();
  
  document.head.appendChild(meta);
};

// Input sanitization
export const sanitizeHtml = (html) => {
  const div = document.createElement('div');
  div.textContent = html;
  return div.innerHTML;
};

// Generate secure random strings
export const generateSecureId = (length = 16) => {
  const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  for (let i = 0; i < length; i++) {
    result += charset.charAt(Math.floor(Math.random() * charset.length));
  }
  
  return result;
};

// Validate URLs
export const isValidUrl = (url) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

// Check if content contains suspicious patterns
export const containsSuspiciousContent = (content) => {
  const suspiciousPatterns = [
    /<script/i,
    /javascript:/i,
    /on\w+\s*=/i,
    /<iframe/i,
    /<embed/i,
    /<object/i
  ];
  
  return suspiciousPatterns.some(pattern => pattern.test(content));
};
